import * as React from "react";
import classNames from "classnames";
import styles from "./EstadoDocumentos.module.scss";
import {Field, Form} from "react-final-form";
import NavigationUserCard from "../../components/UI/NavigationUserCard/NavigationUserCard";
import EstadoDocumentosForm from "./EstadoDocumentosForm";
import TableItem, {TableItemButtonOpProps, TableItemButtonProps} from "../../components/UI/TableItem/TableItem";
import {REQUEST} from "../../util/Request";
import {ValidationUtils} from "../../util/ValidationUtils";
import {DocumentosUtils} from "../../util/DocumentosUtils";
import {TiposArchivoPermitidos, URLs} from "../../util/Constants";
import Dialog from "../../components/UI/Dialog/Dialog";
import BreadcrumbItem from "../../components/UI/Breadcrumb/BreadcrumbItem";
import FileField from "../../components/UI/FileField/FileField";

const moment = require("moment");

export class EstadoDocumentos extends React.Component<any, any> {

  showInfo = false;
  showButton = true;
  estadoDoc = 0;

  constructor(props: any) {
    super(props);

    this.state = {
      docsPending: 0,
      countPendientesAfiliado: 0,
      countPendientesEmpleadores: [],
      countPendientesApoderados: [],
      countPendientesCuradores: [],
      countPendientesReclamantes: [],
      countPendientesBeneficiarios: [],
      countPendientesFormatos: 0,
    };

    if (this.props.solicitud) {
      if (this.props.solicitud.estado === "EN_VALIDACION") {
        this.showInfo = false;
        this.showButton = false;

        this.props.solicitud.documentos.forEach(doc => {
          return doc.estado === "RECHAZADO" ? this.estadoDoc++ : 0;
        });

        if (this.estadoDoc > 0) {
          this.showInfo = true;
          this.showButton = true;
        }

      } else if (this.props.solicitud.estado === "FINALIZADA" ||
        this.props.solicitud.estado === "CANCELADA") {
        this.showInfo = false;
        this.showButton = false;
      }
    }
  }

  componentWillMount() {
    this.setState({
      countPendientesAfiliado: this.props.docsPendientesAfiliado.length,
      countPendientesEmpleadores: this.props.docsPendientesEmpleadores,
      countPendientesApoderados: this.props.docsPendientesApoderados,
      countPendientesCuradores: this.props.docsPendientesCuradores,
      countPendientesReclamantes: this.props.docsPendientesReclamantes,
      countPendientesBeneficiarios: this.props.docsPendientesBeneficiarios,
      countPendientesFormatos: this.props.docsPendientesFormatos.length,
    });
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.estadoVerDocumento === REQUEST.ERROR) {
      this.setState({showErrorDoc: true});
    }
  }

  render() {
    return this.props.solicitud ? (
      <div className={classNames("container-fluid", styles.Container)}>

        <NavigationUserCard id="edAfiliadoUserCard"
                            nombreSolicitante={DocumentosUtils.generarNombrePropietario(this.props.solicitante)}
                            estado={this.props.solicitud.estado}/>

        <BreadcrumbItem to={URLs.ESTADO_DOCUMENTOS} text={"Estado solicitud"}/>

        <div className="row">
          <div className="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12">
            <div className={classNames(styles.ContentContainers, styles.TitleContainer)}>
              <label id="edEntregaDocumentosLbl" className={styles.Title}>Entrega de Documentos</label>
              <br/>
              <label id="edTipoSolicitudLbl" className={styles.Subtitle}>{this.props.solicitud.tipo.descripcion}</label>
            </div>
          </div>
        </div>

        {this.showInfo &&
        <>
          <div className="row justify-content-center">
            <img id="edAlertImg" className={styles.InfoImg} 
              src={require("../../assets/img/icons/alert-circle-grey.svg")}/>
          </div>
          <div className="row justify-content-sm-start justify-content-center">
            <label id="edDocInconsistenciasLbl"
                   className={styles.LabelMedium}>Algunos de los documentos enviados tienen inconsistencias.</label>
          </div>
          <div className="row justify-content-sm-start justify-content-center">
            <label id="edDocRechazosLbl"
                   className={styles.LabelSmall}>Revisa la lista documental para ver la causal de rechazo del documento,
              no olvides volverlo a adjuntar.</label>
          </div>
        </>
        }

        <Form
          onSubmit={this.props.handleSubmit}
          validate={this.props.validateForm}
          mutators={{
            onUploadCancel: (args, state, utils) => {
              utils.changeValue(state, args[0], () => undefined);
              const values = args[1];
              delete values[args[0]];
              this.updateDocumentsCounters(values);
            },
            onUploadConfirm: (args) => {
              this.updateDocumentsCounters(args[0]);
            }
          }}
          render={(finalFormProps) => {
            return (
              <>
                <EstadoDocumentosForm
                  {...finalFormProps}
                  docsAfiliado={this.props.docsAfiliado}
                  docsEmpleador={this.props.docsEmpleadores}
                  docsApoderado={this.props.docsApoderados}
                  docsBeneficiario={this.props.docsBeneficiarios}
                  docsReclamante={this.props.docsReclamantes}
                  docsCurador={this.props.docsCuradores}
                  formatos={this.props.formatos}
                  docsBeneficiariosPropietarios={this.props.docsBeneficiariosPropietarios}
                  docsReclamantesPropietarios={this.props.docsReclamantesPropietarios}
                  docsCuradoresPropietarios={this.props.docsCuradoresPropietarios}
                  docsApoderadosPropietarios={this.props.docsApoderadosPropietarios}
                  docsEmpleadoresPropietarios={this.props.docsEmpleadoresPropietarios}
                  generarFilaDocumento={this.generarFilaDocumento}
                  disabled={this.props.isSubmitButtonDisabled(finalFormProps.errors)}
                  loader={this.props.isLoading()}
                  totalDocsAfiliado={this.props.docsAfiliado.length}
                  pendingDocsAfiliado={Number(this.props.docsAfiliado.length - this.state.countPendientesAfiliado)}
                  totalDocsEmpleador={this.props.docsEmpleadores}
                  pendingDocsEmpleador={this.state.countPendientesEmpleadores}
                  totalDocsApoderado={this.props.docsApoderados}
                  pendingDocsApoderado={this.state.countPendientesApoderados}
                  totalFormatos={this.props.formatos.length}
                  pendingFormatos={this.props.formatos.length - this.state.countPendientesFormatos}
                  totalDocsBeneficiario={this.props.docsBeneficiarios}
                  pendingDocsBeneficiario={this.state.countPendientesBeneficiarios}
                  totalDocsReclamante={this.props.docsReclamantes}
                  pendingDocsReclamante={this.state.countPendientesReclamantes}
                  totalDocsCurador={this.props.docsCuradores}
                  pendingDocsCurador={this.state.countPendientesCuradores}
                  handleGoBack={this.props.goBack}
                  showButton={this.showButton}
                  showAlert={this.props.showAlert}/>
              </>
            );
          }}
        />

        {this.props.showSuccess &&
        <Dialog id="edDocumentosEnviadosDlg"
                icon="check-circle"
                title="Documentos enviados"
                onCancel={this.props.goBack}
                onConfirm={this.props.goBack}
                confirmBtnText="Finalizar">
          Tus documentos han sido enviados exitosamente con fecha {moment(this.props.fechaActual).format("DD/MM/YYYY")}.
          Te notificaremos a trav&eacute;s de tus medios de contacto registrados en
          Protecci&oacute;n en cuanto haya una novedad.
        </Dialog>
        }

      </div>
    ) : "";
  }

  updateDocumentsCounters = (values) => {
    this.setState({
      countPendientesAfiliado: Object.keys(ValidationUtils
        .validateRequiredFields(this.props.docsPendientesAfiliado, values)).length,
      countPendientesEmpleadores: ValidationUtils
        .validateDocMultipleUsers(this.state.countPendientesEmpleadores, values),
      countPendientesApoderados: ValidationUtils
        .validateDocMultipleUsers(this.state.countPendientesApoderados, values),
      countPendientesCuradores: ValidationUtils
        .validateDocMultipleUsers(this.state.countPendientesCuradores, values),
      countPendientesReclamantes: ValidationUtils
        .validateDocMultipleUsers(this.state.countPendientesReclamantes, values),
      countPendientesBeneficiarios: ValidationUtils
        .validateDocMultipleUsers(this.state.countPendientesBeneficiarios, values),
      countPendientesFormatos: Object.keys(ValidationUtils
        .validateRequiredFields(this.props.docsPendientesFormatos, values)).length,
    });
  }

  getLastRejectionObservation = (rechazos) => {
    let maxDate;
    if (rechazos && rechazos.length) {
      maxDate = rechazos[0];
      if (rechazos.length > 1) {
        let auxDate = rechazos[0].fecha;
        rechazos.map(date => {
          if (date.fecha > auxDate) {
            maxDate = date;
            auxDate = date.fecha;
          } else {
            auxDate = date.fecha;
          }
        });
      }
    } else {
      maxDate = {
        causal: "No especificado",
        descripcion: "No especificado",
      };
    }

    return (
      <>
        <strong>Causal: </strong> {maxDate.causal}<br/>
        <strong>Detalle: </strong>{maxDate.descripcion}
      </>
    );
  }

  generarFilaDocumento = (doc, values, mutators, isTemplateRow) => {

    let showButtonUploadFile = false;
    let showButtonPrintTemplate = false;
    let showHoverButtons = false;
    let observation;

    const idDoc = DocumentosUtils.generarIdDocumento(doc);

    const buttonPrintTemplateProps: TableItemButtonProps = {
      id: "edDescargarBtn" + idDoc,
      name: "edDescargarBtn" + idDoc,
      text: "Descargar Formato",
      loader: true,
      icon: "eye-blue",
      onClick: () => this.props.downloadTemplate(doc)
    };
    const buttonUploadFileProps: TableItemButtonOpProps = {
      id: "edReemplazarBtn" + idDoc,
      name: "edReemplazarBtn" + idDoc,
      text: "Reemplazar",
      loader: true,
      icon: "refresh-cw-blue"
    };

    switch (doc.estado) {
      case "RECHAZADO": {
        showHoverButtons = true;
        showButtonUploadFile = true;
        showButtonPrintTemplate = isTemplateRow;
        observation = this.getLastRejectionObservation(doc.rechazos);
        break;
      }
      case "APROBADO": {
        observation = "El documento se encuentra aprobado";
        break;
      }
      case "RECIBIDO":
      case "ENVIADO":
      case "ALMACENADO": {
        observation = "El documento se encuentra en espera de revisión";
        break;
      }
    }

    let uploadDate = doc.fechaCarga;
    if (doc.fechaCarga) {
      uploadDate = moment(doc.fechaCarga).format("DD/MM/YYYY");
    }

    return (
      <div key={"ROW" + idDoc}>

        <TableItem id={idDoc}
                   title={doc.nombre}
                   estado={doc.estado}
                   observaciones={observation}
                   fechaCarga={uploadDate}
                   button={showButtonPrintTemplate}
                   buttonProps={buttonPrintTemplateProps}
                   buttonOp={showButtonUploadFile}
                   buttonOpProps={buttonUploadFileProps}
                   hoverButtons={showHoverButtons}
                   onUploadCancel={() => mutators.onUploadCancel(idDoc, values)}
                   onUploadConfirm={() => mutators.onUploadConfirm(values)}/>

        <Field component={FileField}
               id={idDoc}
               name={idDoc}
               cssClassName={styles.Invisible}
               allowedMimeTypes={TiposArchivoPermitidos}/>

      </div>
    );

  }

}

export default EstadoDocumentos;
